// src/components/admin/rejectBiddingModal/RejectBiddingModal.jsx
import React, { useState } from "react";
import Modal from "../../customer/modal/Modal";
import "../../../assets/css/admin/rejectBiddingModal/RejectBiddingModal.css";

const RejectBiddingModal = ({ isOpen, onClose, bidding, onReject }) => {
  const [reason, setReason] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const commonReasons = [
    "Item quality does not meet platform standards",
    "Incomplete or misleading product description",
    "Inappropriate or prohibited item category",
    "Insufficient or poor quality images",
    "Suspected fraudulent activity",
    "Pricing concerns or unrealistic valuation",
    "Other (please specify below)",
  ];

  const handleReasonSelect = (selected) => {
    setSelectedReason(selected);
    if (selected !== "Other (please specify below)") {
      setReason(selected);
    } else {
      setReason("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      alert("Please provide a rejection reason");
      return;
    }

    setIsSubmitting(true);

    // Call parent's reject function
    // Replace this with: await api.rejectBidding(bidding.id, reason.trim())
    setTimeout(() => {
      onReject(reason.trim());
      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        setIsSubmitting(false);
        handleClose();
      }, 1500);
    }, 800);
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setReason("");
      setSelectedReason("");
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Reject Bidding"
      size="medium"
    >
      {showSuccess ? (
        <div className="reject-bid-success">
          <div className="reject-bid-success-icon">✓</div>
          <h3>Bidding Rejected</h3>
          <p>The seller has been notified about the rejection.</p>
        </div>
      ) : (
        <form className="reject-bid-form" onSubmit={handleSubmit}>
          <div className="reject-bid-info">
            <div className="reject-bid-info-image">
              <img
                src={bidding.productImages?.[0] || "/default.png"}
                alt={bidding.productName}
                className="reject-bid-img"
              />
            </div>
            <div className="reject-bid-info-details">
              <h4>{bidding.productName}</h4>
              <p>Seller: {bidding.sellerName}</p>
            </div>
          </div>

          <div className="reject-bid-reasons">
            <label className="reject-bid-label">Select Rejection Reason:</label>
            <div className="reject-bid-reasons-list">
              {commonReasons.map((commonReason, index) => (
                <label key={index} className="reject-bid-reason-item">
                  <input
                    type="radio"
                    name="reason"
                    value={commonReason}
                    checked={selectedReason === commonReason}
                    onChange={(e) => handleReasonSelect(e.target.value)}
                  />
                  <span>{commonReason}</span>
                </label>
              ))}
            </div>
          </div>

          {(selectedReason === "Other (please specify below)" ||
            selectedReason === "") && (
            <div className="reject-bid-custom">
              <label htmlFor="customReason" className="reject-bid-label">
                {selectedReason === "Other (please specify below)"
                  ? "Please specify the reason:"
                  : "Or enter custom reason:"}
              </label>
              <textarea
                id="customReason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter detailed rejection reason..."
                rows={4}
                className="reject-bid-textarea"
              />
            </div>
          )}

          <div className="reject-bid-actions">
            <button
              type="button"
              className="reject-bid-cancel-btn"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="reject-bid-submit-btn"
              disabled={isSubmitting || !reason.trim()}
            >
              {isSubmitting ? "Rejecting..." : "Reject Bidding"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default RejectBiddingModal;
